import React, { Component } from 'react';
import PropTypes from 'prop-types';
import X from 'wix-ui-icons-common/X';
import PrettyIcon from '../PrettyIcon';
import CurrencyUtils from '@wix/wixrest-utils/dist/CurrencyUtils';
import { translate } from 'react-i18next';

import styles from './Tip.scss';
import { CurrencyInput } from './CurrencyInput';

import { TextButton, Text } from 'wix-style-react';

class Tip extends Component {
  state = {
    showAddTip: false,
  };

  onAddTip = () => {
    this.setState({ showAddTip: true });
  };

  onRemoveTip = () => {
    this.setState({ showAddTip: false });
    this.props.onRemove();
  };

  onTipChange = number => {
    this.props.onChange(number);
  };

  render() {
    const { currency, t, tip } = this.props;
    const { showAddTip } = this.state;
    const currencySymbol = CurrencyUtils.currencySymbol(currency);
    const prefix = <span data-hook="tip-prefix">{currencySymbol}</span>;
    return (
      <div className={styles.root} data-hook="payment-line-add-tip-root">
        {!tip && !showAddTip ? (
          <TextButton dataHook="payment-line-add-tip-button" onClick={this.onAddTip}>
            {t('phoneordering_checkout_addtip_cta')}
          </TextButton>
        ) : (
          <div className={styles.addTip} data-hook="payment-line-add-tip-section">
            <Text size="medium" weight="normal">
              Tip on card:
            </Text>
            <div className={styles.paymentGroup}>
              <CurrencyInput
                locale={this.props.locale}
                currency={this.props.currency}
                value={tip}
                onChange={this.onTipChange}
                prefix={prefix}
              />
              <PrettyIcon
                className={styles.closeButton}
                data-hook="payment-line-remove-tip-button"
                onClick={this.onRemoveTip}
              >
                <X />
              </PrettyIcon>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Tip.propTypes = {
  tip: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  t: PropTypes.func,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

export default translate()(Tip);
